
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

export interface AssessmentSession {
  sessionId: string;
  startTime: Date;
}

export const useAssessmentSession = () => {
  const [session, setSession] = useState<AssessmentSession | null>(null);
  const { user } = useAuth();

  useEffect(() => {
    // Create a new session when the hook is first used
    const sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    setSession({
      sessionId,
      startTime: new Date()
    });
  }, []);

  const saveAssessmentHistory = async (answers: Record<string, any>, result: any) => {
    if (!session || !user?.id) {
      console.warn('Cannot save assessment history: user must be authenticated');
      return;
    }

    try {
      const { error } = await supabase
        .from('assessment_histories')
        .insert({
          session_id: session.sessionId,
          questions_answers: answers,
          result: result,
          user_id: user.id,
        });

      if (error) {
        console.error('Error saving assessment history:', error);
      } else {
        console.log('Assessment history saved successfully');
      }
    } catch (error) {
      console.error('Error saving to database:', error);
    }
  };

  return {
    session,
    saveAssessmentHistory
  };
};
